import styled from "styled-components";
import { getColor } from "../../../../../../../utils/color";

export const TRow = styled.tr`
  th,
  td {
    font-size: 1rem;
    text-align: left;
    padding: 0.5rem 1rem;
  }

  th {
    padding: 0.5rem 1rem;
    color: ${({ theme }) => theme.colors.primaryBlue.text};
    &:first-child {
      border-top-left-radius: 0.5rem;
    }
    &:last-child {
      border-top-right-radius: 0.5rem;
    }
    background-color: ${({ theme }) => theme.colors.primaryBlue.main};
  }

  .center {
    text-align: center;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  border-radius: 1rem !important;
  padding: 0.5rem;
  background-color: #fff;
  tr:first-child {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
`;

export const RemoveButton = styled.button`
  border: none;
  background-color: transparent;
  color: ${({ theme }) => getColor(theme.colors.primaryBlue.main).hover};

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
  }
`;
